import gql from 'graphql-tag';

const GET_TASKS_BY_CAMPAIGN = gql`
  query getTasksByCampaign($where: TaskWhereInput, $orderBy: TaskOrderByInput) {
    tasksConnection(
      where: $where
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          name
          status
          urgency
          createdAt
          updatedAt
          dueDate
          startDate
          requestType
          requestSubType
          taskDetails
          linkUrl
          createdBy {
            id
            name
            username
            avatar {
              id
              key
            }
          }
          assigneeUsers {
            id
            name
            username
            avatar {
              id
              key
            }
          }
          assigneeUser {
            id
            name
            username
            avatar {
              id
              key
            }
          }
          channelPartner {
            id
            name
          }
          advertiser {
            id
            name
          }
          attachedComments {
            id
            comment
            createdAt
            createdBy {
              id
              name
              username
              avatar {
                id
                key
              }
            }
            attachedFiles {
              id
              name
              url
              key
            }
            attachedImages {
              id
              name
              url
              key
            }
            codeSnippet
          }
        }
      }
      aggregate {
        count
      }
    }
  }
`;

export default GET_TASKS_BY_CAMPAIGN;
